import React from 'react'
import styled from 'styled-components'
import Box from 'core-system/Box/Box'
import TitleChange from './TitleChange'
import { ChangeVariant } from './TitleChange'

const Container = styled(Box)`
  padding: 1.5rem;
  height: 100%;
`

interface CommutersMetricsProps {
  title: string
  subtitle: string
  change?: string
  isLoading?: boolean
  variant?: ChangeVariant
  titleFontWeight?: number
  titleVariant?: string
}

const CommutersMetrics = ({
  title,
  subtitle,
  change,
  isLoading = false,
  variant = 'positive',
  titleFontWeight,
  titleVariant,
}: CommutersMetricsProps) => {
  return (
    <Container isLoading={isLoading}>
      <TitleChange
        title={title}
        subtitle={subtitle}
        change={change}
        variant={variant}
        titleFontWeight={titleFontWeight}
        titleVariant={titleVariant}
      />
    </Container>
  )
}

export default CommutersMetrics
